const TZ = 'America/Sao_Paulo';

const partsFmt = new Intl.DateTimeFormat('en-US', {
  timeZone: TZ,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

function spParts(d) {
  const parts = {};
  partsFmt.formatToParts(d).forEach(({ type, value }) => {
    parts[type] = value;
  });
  if (parts.hour === '24') parts.hour = '00';
  return parts;
}

// "2026-07-08" para o Date em São Paulo
export function spDateKey(d) {
  const p = spParts(d instanceof Date ? d : new Date(d));
  return `${p.year}-${p.month}-${p.day}`;
}

// Minutos desde meia-noite SP para posicionar na grade
export function spMinutesSinceMidnight(iso) {
  if (!iso) return 0;
  const p = spParts(new Date(iso));
  return parseInt(p.hour, 10) * 60 + parseInt(p.minute, 10);
}

// Hora SP (0-23) para filtrar reuniões por slot
export function spHour(iso) {
  if (!iso) return 0;
  return parseInt(spParts(new Date(iso)).hour, 10);
}

// Minutos atuais em SP para a linha "agora"
export function spNowMinutes() {
  return spMinutesSinceMidnight(new Date().toISOString());
}

// Formata horário em pt-BR no fuso SP
export function formatTimeSP(iso) {
  if (!iso) return '';
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: TZ,
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
}

// ISO UTC → "2026-07-08T14:00" (para input datetime-local no fuso SP)
export function toSpDatetimeLocal(iso) {
  if (!iso) return '';
  const p = spParts(new Date(iso));
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}

// "2026-07-08T14:00" (wall clock SP) → ISO UTC
export function fromSpDatetimeLocal(val) {
  if (!val) return null;
  const [date, time] = val.split('T');
  const [yr, mo, dy] = date.split('-').map(Number);
  const [hr, mn] = time.split(':').map(Number);

  // Estimativa inicial com offset -3h
  const guessUtc = Date.UTC(yr, mo - 1, dy, hr + 3, mn);

  // Calcular offset real do TZ naquele instante
  function spWallMs(utcMs) {
    const p = {};
    partsFmt.formatToParts(new Date(utcMs)).forEach(({ type, value }) => {
      p[type] = value;
    });
    const h = p.hour === '24' ? 0 : parseInt(p.hour, 10);
    return Date.UTC(
      parseInt(p.year, 10),
      parseInt(p.month, 10) - 1,
      parseInt(p.day, 10),
      h,
      parseInt(p.minute, 10)
    );
  }

  const targetMs = Date.UTC(yr, mo - 1, dy, hr, mn);
  const offsetMs = guessUtc - spWallMs(guessUtc);
  return new Date(targetMs + offsetMs).toISOString();
}

// Data + hora completas em pt-BR no fuso SP (para a view Lista)
export function formatFullDateTimeSP(iso) {
  if (!iso) return '';
  const formatted = new Intl.DateTimeFormat('pt-BR', {
    timeZone: TZ,
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(iso));
  return formatted.replace(' às ', ', ');
}
